/**
 * [平台账户]
 * @author: Fu Xiaochun
 * @date: 2022-11-28 
 */

import http from '@/assets/api/http';


// 获取普惠钱包相关信息获取普惠钱包相关信息
export async function getUnionWalletInfo(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.pay.UnionWalletMisService.getPigWalletAlert', params, 'POST');
}

// 平台账户余额查询
export async function getPlatformAccountBalance(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.pay.PlatAcctMisService.getQueryLLAcctBalResp', params, 'POST');
}

// 平台身边云账户余额查询
export async function getYoufuAccountBalance(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.pay.PlatAcctMisService.getQueryYouFuAcctBalResp', params, 'POST');
}

// 平台身边云账户-服务商
export async function getYoufuServiceMerchants(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.pay.PlatAcctMisService.getYouFuLevyInfo', params, 'POST');
}

// 连连手续费账户充值
export async function lianlianServiceRecharge(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.pay.PlatAcctMisService.insideTransfer', params, 'POST');
}

// 连连平台账户提现
export async function lianlianPlatformWithdrawal(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.pay.PlatAcctMisService.llPlatWithdrawal', params, 'POST');
}

// 获取余额提醒设置
export async function getPigWalletAlert(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.pay.PigWalletContactConfigMisService.getPigWalletAlert', params, 'POST');
}

// 更新余额提醒设置
export async function updatePigWalletAlert(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.pay.PigWalletContactConfigMisService.savePigWalletAlert', params, 'POST');
}

// 获取骑手押金账户
export async function getRiderDepositAccount(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.pay.PlatAcctMisService.getDepositChannelBalanceResp', params, 'POST');
}